import { escape } from "es-toolkit/string"
import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { highlightSearch } from "@/lib/highlight-search"
import { cn } from "@/lib/utils"

interface HighlightCellTextProps extends React.ComponentPropsWithoutRef<"span"> {
  text: string
  globalFilter?: string
}

export const HighlightCellText = ({ text, globalFilter, className, ...otherProps }: HighlightCellTextProps) => {
  if (!globalFilter || !globalFilter.length || globalFilter.length < 3)
    return (
      <span className={className} {...otherProps}>
        {text}
      </span>
    )

  return (
    <PotentiallyUnsafeInnerHtml
      className={cn("inline", className)}
      value={highlightSearch(escape(text), escape(globalFilter.trim()))}
      {...otherProps}
    />
  )
}
